import { MealTypeId } from 'types/mealTypes/mealTypes';

export const MEAL_TYPES = 'api/v1/meal-types';
export const MEAL_TYPE = (mealTypeId: MealTypeId) => `api/v1/meal-types/${mealTypeId}`;
